module.exports = __webpack_public_path__ + "static/media/download_blue.606e30b4.svg";